export const defaultOrg: CMxCommonApp.FieldDefinition = {
  key: 'defaultOrg',
  name: 'defaultOrg',
  label: 'Organization',
  options: [],
  type: 'select',
  placeholder: 'Select',
  labelField: 'organizationName',
  valueField: 'organizationId',
  helpText: 'Automatically login under this organization'
};

export const defaultServiceLine: CMxCommonApp.FieldDefinition = {
  key: 'defaultServiceLine',
  name: 'defaultServiceLine',
  label: 'Service Line',
  options: [],
  type: 'select',
  placeholder: 'Select',
  labelField: 'name',
  valueField: 'id',
  helpText: 'Automatically choose this service line'
};

export const defaultHomepage: CMxCommonApp.FieldDefinition = {
  key: 'defaultHomepage',
  name: 'defaultHomepage',
  label: 'Homepage',
  options: [],
  type: 'select',
  placeholder: 'Select',
  labelField: 'label',
  valueField: 'path',
  helpText: 'Automatically open to this page on login'
};

export const demographicsPanel: CMxCommonApp.FieldDefinition = {
  key: 'demographicsPanel',
  name: 'demographicsPanel',
  label: 'Case Demographics Panel',
  type: 'multiField',
  fields: [
    {
      key: 'demographicsPanelLocation',
      name: 'demographicsPanelLocation',
      label: 'Location',
      type: 'radio',
      options: [
        { label: 'Right', value: 'right' },
        { label: 'Bottom', value: 'bottom' }
      ],
      labelField: 'label',
      valueField: 'value'
    },
    {
      key: 'demographicsPanelVisibility',
      name: 'demographicsPanelVisibility',
      label: 'Visibility',
      type: 'radio',
      options: [
        { label: 'Open', value: 'open' },
        { label: 'Closed', value: 'closed' }
      ],
      labelField: 'label',
      valueField: 'value'
    }
  ],
  helpText: 'Configure default panel position and visibility'
};

export const noDefaultOrgOption: Partial<CMxAPI.OrganizationContext> = {
  organizationId: -1,
  organizationName: 'None'
};

export const noDefaultServiceLineOption: CMxAPI.ServiceLine = {
  id: -1,
  name: 'None'
};

export const noDefaultHomepageOption = {
  label: 'None',
  path: 'None'
};

export const defaultsFieldGroup: CMxCommonApp.FieldGroup = {
  label: 'Account Defaults',
  fields: [defaultOrg, defaultServiceLine, defaultHomepage]
};

const formDefinition: CMxCommonApp.FormDefintion = {
  fieldGroups: [defaultsFieldGroup],
  buttons: [{ buttonType: 'submit', buttonText: 'Save' }]
};

const formObject = {
  defaultOrg: undefined,
  defaultServiceLine: undefined,
  organizationId: undefined,
  defaultHomepage: undefined,
  demographicsPanelLocation: undefined,
  demographicsPanelVisibility: undefined
};
export const accountSettings: CMx.AccountSettingsState = {
  isOpen: false,
  accountDefaults: {
    formDefinition,
    formObject
  }
};
